document.addEventListener("DOMContentLoaded", () => {
  const persons = document.querySelectorAll(".contact_persons .content-text");
  const filterContainer = document.querySelector(".tag-filter--inner");

  if (!filterContainer) return;

  // Alle Tags einsammeln: Map alias → label (sichtbarer Text)
  const tagMap = new Map();

  persons.forEach(person => {
    const tagLis = person.querySelectorAll(".ce_tags li[data-alias]");
    tagLis.forEach(li => {
      const alias = li.dataset.alias;
      const label = li.textContent.trim();
      if (alias && label) {
        tagMap.set(alias, label); // unique alias → readable label
      }
    });
  });

  // Buttons erzeugen
  filterContainer.innerHTML = "";
  tagMap.forEach((label, alias) => {
    const btn = document.createElement("button");
    btn.className = "button button--icon";
    btn.dataset.filter = alias;
    btn.innerHTML = `<span>${label}</span>`;
    filterContainer.appendChild(btn);
  });

  // URL-Parameter auslesen
  const params = new URLSearchParams(window.location.search);
  let activeTags = params.get("tags") ? params.get("tags").split(",") : [];

  // Initial filtern
  if (activeTags.length > 0) {
    filterPersons(activeTags);
    setActiveButtons();
  }

  // Button-Klicks
  filterContainer.addEventListener("click", e => {
    const btn = e.target.closest("button");
    if (!btn) return;

    const tag = btn.dataset.filter;
    if (activeTags.includes(tag)) {
      activeTags = activeTags.filter(t => t !== tag);
    } else {
      activeTags.push(tag);
    }

    filterPersons(activeTags);
    setActiveButtons();

    // URL aktualisieren
    const newParams = new URLSearchParams(window.location.search);
    if (activeTags.length > 0) {
      newParams.set("tags", activeTags.join(","));
    } else {
      newParams.delete("tags");
    }
    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    history.replaceState({}, "", newUrl);
  });

  function filterPersons(tags) {
    persons.forEach(person => {
      const aliases = [...person.querySelectorAll(".ce_tags li[data-alias]")]
        .map(li => li.dataset.alias);

      if (tags.length === 0 || tags.some(t => aliases.includes(t))) {
        person.classList.remove("is-hidden");
        person.classList.add("is-showing");
        setTimeout(() => person.classList.remove("is-showing"), 300);
      } else {
        person.classList.add("is-hiding");
        setTimeout(() => {
          person.classList.remove("is-hiding");
          person.classList.add("is-hidden");
        }, 300);
      }
    });
  }

  function setActiveButtons() {
    filterContainer.querySelectorAll("button").forEach(btn => {
      btn.classList.toggle("is-active", activeTags.includes(btn.dataset.filter));
    });
  }
});